
export { ApprovedFooter } from "./ui"